import { render, staticRenderFns } from "./OfftakeSuitabilitySummary.vue?vue&type=template&id=aee4ffea&scoped=true&"
import script from "./OfftakeSuitabilitySummary.vue?vue&type=script&lang=js&"
export * from "./OfftakeSuitabilitySummary.vue?vue&type=script&lang=js&"
import style0 from "./OfftakeSuitabilitySummary.vue?vue&type=style&index=0&id=aee4ffea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee4ffea",
  null
  
)

export default component.exports